import { FC } from 'react';
import ModalAtom from 'components/atoms/ModalAtom';
import PrimaryButton from 'components/atoms/Button/PrimaryButton';
import DefaultButton from 'components/atoms/Button/DefaultButton';

interface Props {
  title: string;
  text: string;
  mainButtonText: string;
  secondaryButtonText: string;
  list: string[];
  onClickMainButton: () => Promise<void>;
  onCancel: () => void;
  visible: boolean;
  loading: boolean;

}

const UpdateAccessPasswordErrorModal: FC<Props> = ({
  title,
  text,
  mainButtonText,
  secondaryButtonText,
  list,
  onClickMainButton,
  onCancel,
  visible,
  loading,
}) => {
  return (
    <ModalAtom
      title={title}
      onCancel={onCancel}
      open={visible}
      destroyOnClose
      footer={[
        <DefaultButton key={'back'} onClick={onCancel} title={secondaryButtonText} />,
        <PrimaryButton key={'confirm'} loading={loading} title={mainButtonText} onClick={onClickMainButton} />,
      ]}
    >
      <div>{text}</div>
      <ul>
        {list.map((listItem, key) => {
          return (
            <li key={key}>{listItem}</li>
          )
        })}
      </ul>
    </ModalAtom>
  );
};

export default UpdateAccessPasswordErrorModal;
